import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'score',
    pure: false
})
export class ScoreViewPipe implements PipeTransform {

    transform(val: any[], ...args: any[]): any[] {
        if (!Array.isArray(val)) {
            return val;
        }

        let id = args[0]
        let arr: any[] = []

            if (id === 2 || id === 3) {
                if (val.length <= 2) {
                    arr = [val[0]]
                } else {
                    arr = val
                }
            } else if (id === 1) {
                if (val.length <= 2) {
                    arr = [val[0]]
                } else {
                    arr = [...val]
                    arr.splice(2, 1)
                }
            } else if (id === 30) {
                if (val.length > 2) {
                    arr = [...val]
                    arr.splice(1, val.length - 2)
                } else {
                    arr = val
                }
            } else {
                arr = val
            }

        return arr;
    }

}
